import { ConditionValueInputComponent } from 'Automations/nodeDefinitions/conditions'
import { CurrencySelector } from './components/CurrencySelector'

/**
 * Picks a currency CODE as the value (e.g. for the `CURRENCY` property's
 * `EQUALS`/`NOT_EQUALS` operators).
 */
export const CurrencyValueInput: ConditionValueInputComponent = ({
  'data-testid': dataTestId,
  value,
  onChange,
  validationErrors
}) => (
  <CurrencySelector
    data-testid={dataTestId ? `${dataTestId}.value` : undefined}
    value={value}
    onChange={next => onChange({ value: next })}
    validationErrors={validationErrors}
  />
)
